export class HistoricoFinanceiro {
  public id!: number | null;
  public ativo!: boolean;
  public nome!: string;
  public tipoEntradaSaida!: string;
  public codigoLancamento!: number;
}